// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_usage.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppUsageControlsService } from "./app_usage";
import type { CountInactiveUsersForAppResponse } from "./app_usage";
import type { CountInactiveUsersForAppRequest } from "./app_usage";
import type { SearchInactiveUsersPastThirtyDaysForAllAppsResponse } from "./app_usage";
import type { SearchInactiveUsersPastThirtyDaysForAllAppsRequest } from "./app_usage";
import type { CountInactiveUsersPastThirtyDaysResponse } from "./app_usage";
import type { CountInactiveUsersPastThirtyDaysRequest } from "./app_usage";
import type { SearchInactiveUsersResponse } from "./app_usage";
import type { SearchInactiveUsersRequest } from "./app_usage";
import type { GetNotLoggedInCountResponse } from "./app_usage";
import type { GetNotLoggedInCountRequest } from "./app_usage";
import type { UpdateAppUsageControlsResponse } from "./app_usage";
import type { UpdateAppUsageControlsRequest } from "./app_usage";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAppUsageControlsResponse } from "./app_usage";
import type { GetAppUsageControlsRequest } from "./app_usage";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppUsageControlsService
 */
export interface IAppUsageControlsServiceClient {
    /**
     * Get usage controls, as an AppUsageControls object which describes some peripheral configuration, for an app.
     *
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetAppUsageControlsRequest) returns (c1.api.app.v1.GetAppUsageControlsResponse);
     */
    get(input: GetAppUsageControlsRequest, options?: RpcOptions): UnaryCall<GetAppUsageControlsRequest, GetAppUsageControlsResponse>;
    /**
     * Update usage controls for an app.
     *
     * @generated from protobuf rpc: Update(c1.api.app.v1.UpdateAppUsageControlsRequest) returns (c1.api.app.v1.UpdateAppUsageControlsResponse);
     */
    update(input: UpdateAppUsageControlsRequest, options?: RpcOptions): UnaryCall<UpdateAppUsageControlsRequest, UpdateAppUsageControlsResponse>;
    /**
     * @generated from protobuf rpc: GetNotLoggedInCount(c1.api.app.v1.GetNotLoggedInCountRequest) returns (c1.api.app.v1.GetNotLoggedInCountResponse);
     */
    getNotLoggedInCount(input: GetNotLoggedInCountRequest, options?: RpcOptions): UnaryCall<GetNotLoggedInCountRequest, GetNotLoggedInCountResponse>;
    /**
     * @generated from protobuf rpc: SearchInactiveUsers(c1.api.app.v1.SearchInactiveUsersRequest) returns (c1.api.app.v1.SearchInactiveUsersResponse);
     */
    searchInactiveUsers(input: SearchInactiveUsersRequest, options?: RpcOptions): UnaryCall<SearchInactiveUsersRequest, SearchInactiveUsersResponse>;
    /**
     * @generated from protobuf rpc: CountInactiveUsersPastThirtyDays(c1.api.app.v1.CountInactiveUsersPastThirtyDaysRequest) returns (c1.api.app.v1.CountInactiveUsersPastThirtyDaysResponse);
     */
    countInactiveUsersPastThirtyDays(input: CountInactiveUsersPastThirtyDaysRequest, options?: RpcOptions): UnaryCall<CountInactiveUsersPastThirtyDaysRequest, CountInactiveUsersPastThirtyDaysResponse>;
    /**
     * @generated from protobuf rpc: SearchInactiveUsersPastThirtyDaysForAllApps(c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsRequest) returns (c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsResponse);
     */
    searchInactiveUsersPastThirtyDaysForAllApps(input: SearchInactiveUsersPastThirtyDaysForAllAppsRequest, options?: RpcOptions): UnaryCall<SearchInactiveUsersPastThirtyDaysForAllAppsRequest, SearchInactiveUsersPastThirtyDaysForAllAppsResponse>;
    /**
     * @generated from protobuf rpc: CountInactiveUsersForApp(c1.api.app.v1.CountInactiveUsersForAppRequest) returns (c1.api.app.v1.CountInactiveUsersForAppResponse);
     */
    countInactiveUsersForApp(input: CountInactiveUsersForAppRequest, options?: RpcOptions): UnaryCall<CountInactiveUsersForAppRequest, CountInactiveUsersForAppResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppUsageControlsService
 */
export class AppUsageControlsServiceClient implements IAppUsageControlsServiceClient, ServiceInfo {
    typeName = AppUsageControlsService.typeName;
    methods = AppUsageControlsService.methods;
    options = AppUsageControlsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get usage controls, as an AppUsageControls object which describes some peripheral configuration, for an app.
     *
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetAppUsageControlsRequest) returns (c1.api.app.v1.GetAppUsageControlsResponse);
     */
    get(input: GetAppUsageControlsRequest, options?: RpcOptions): UnaryCall<GetAppUsageControlsRequest, GetAppUsageControlsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppUsageControlsRequest, GetAppUsageControlsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update usage controls for an app.
     *
     * @generated from protobuf rpc: Update(c1.api.app.v1.UpdateAppUsageControlsRequest) returns (c1.api.app.v1.UpdateAppUsageControlsResponse);
     */
    update(input: UpdateAppUsageControlsRequest, options?: RpcOptions): UnaryCall<UpdateAppUsageControlsRequest, UpdateAppUsageControlsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAppUsageControlsRequest, UpdateAppUsageControlsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetNotLoggedInCount(c1.api.app.v1.GetNotLoggedInCountRequest) returns (c1.api.app.v1.GetNotLoggedInCountResponse);
     */
    getNotLoggedInCount(input: GetNotLoggedInCountRequest, options?: RpcOptions): UnaryCall<GetNotLoggedInCountRequest, GetNotLoggedInCountResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetNotLoggedInCountRequest, GetNotLoggedInCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchInactiveUsers(c1.api.app.v1.SearchInactiveUsersRequest) returns (c1.api.app.v1.SearchInactiveUsersResponse);
     */
    searchInactiveUsers(input: SearchInactiveUsersRequest, options?: RpcOptions): UnaryCall<SearchInactiveUsersRequest, SearchInactiveUsersResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchInactiveUsersRequest, SearchInactiveUsersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountInactiveUsersPastThirtyDays(c1.api.app.v1.CountInactiveUsersPastThirtyDaysRequest) returns (c1.api.app.v1.CountInactiveUsersPastThirtyDaysResponse);
     */
    countInactiveUsersPastThirtyDays(input: CountInactiveUsersPastThirtyDaysRequest, options?: RpcOptions): UnaryCall<CountInactiveUsersPastThirtyDaysRequest, CountInactiveUsersPastThirtyDaysResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountInactiveUsersPastThirtyDaysRequest, CountInactiveUsersPastThirtyDaysResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchInactiveUsersPastThirtyDaysForAllApps(c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsRequest) returns (c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsResponse);
     */
    searchInactiveUsersPastThirtyDaysForAllApps(input: SearchInactiveUsersPastThirtyDaysForAllAppsRequest, options?: RpcOptions): UnaryCall<SearchInactiveUsersPastThirtyDaysForAllAppsRequest, SearchInactiveUsersPastThirtyDaysForAllAppsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchInactiveUsersPastThirtyDaysForAllAppsRequest, SearchInactiveUsersPastThirtyDaysForAllAppsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountInactiveUsersForApp(c1.api.app.v1.CountInactiveUsersForAppRequest) returns (c1.api.app.v1.CountInactiveUsersForAppResponse);
     */
    countInactiveUsersForApp(input: CountInactiveUsersForAppRequest, options?: RpcOptions): UnaryCall<CountInactiveUsersForAppRequest, CountInactiveUsersForAppResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountInactiveUsersForAppRequest, CountInactiveUsersForAppResponse>("unary", this._transport, method, opt, input);
    }
}
